import { put, select } from 'typed-redux-saga';

import { NOTIFICATIONS_MAP, notify } from '../../../../../shared/features/notifications/ps-notifications';
import { AccessLevel } from '../../../../../types';
import { isSelfModerator as isSelfModeratorSelector, selectIsWaitingRoomEnabled } from '../../../selectors';
import { NotificationId } from '../../../types';
import { updateBroadcastSettings, updateConferenceAccessLevel } from '../slice';

export function* conferenceAccessLevelChangeSaga(accessLevel: AccessLevel) {
    yield* put(updateConferenceAccessLevel(accessLevel));

    const isSelfModerator = yield* select(isSelfModeratorSelector);

    if (isSelfModerator) {
        const isWaitingRoomEnabled = yield* select(selectIsWaitingRoomEnabled);
        yield* put(
            notify(NOTIFICATIONS_MAP[NotificationId.CONFERENCE_ACCESS_LEVEL_CHANGE](accessLevel, isWaitingRoomEnabled))
        );
    }
}

export function* broadcastAccessLevelChangeSaga(accessLevel: AccessLevel) {
    yield* put(
        updateBroadcastSettings({
            access_level: accessLevel,
        })
    );

    const isSelfModerator = yield* select(isSelfModeratorSelector);

    if (isSelfModerator) {
        yield* put(notify(NOTIFICATIONS_MAP[NotificationId.BROADCAST_ACCESS_LEVEL_CHANGE](accessLevel)));
    }
}
